import React, { useState } from "react";
import Sidebar from "./../../screens/student/studentdashboard/Sidebar";
import Header from "./../../screens/student/studentdashboard/Header";
import "./../../assets/css/student/MyStudentLayout.css";

const StudentLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  // ── localStorage se user data ──
  const studentData = JSON.parse(localStorage.getItem("studentData") || "{}");
  const firstName =
    studentData?.firstName || localStorage.getItem("firstName") || "";
  const lastName =
    studentData?.lastName || localStorage.getItem("lastName") || "";
  const email = studentData?.email || localStorage.getItem("email") || "";
  const fullName =
    firstName && lastName
      ? `${firstName} ${lastName}`
      : firstName || email.split("@")[0] || "Student";

  return (
    <div
      className="student-layout"
      style={{ "--current-sidebar-w": collapsed ? "68px" : "260px" }}
    >
      {/* Sidebar */}
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((p) => !p)}
        studentName={fullName}
        studentEmail={email}
        studentRole="Student"
      />

      {/* Header */}
      <Header
        collapsed={collapsed}
        studentName={fullName}
        studentEmail={email}
      />

      {/* Main Content */}
      <main
        className="student-main"
        style={{
          marginLeft: collapsed ? "68px" : "260px",
          marginTop: "67px",
          height: "calc(100vh - 67px)",
          overflow: "hidden",
          position: "relative",
          background: "#f9fafb",
          transition: "margin-left 0.28s cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        <div
          className="student-content"
          style={{
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            background: "#f9fafb",
          }}
        >
          {children}
        </div>
      </main>
    </div>
  );
};

export default StudentLayout;
